import {
  REQUEST_BRAND_DETAILS,
  RECEIVE_BRAND_DETAILS,
  BRAND_DETAILS_ERROR
} from '../actions/brands'

const initialState = {
  isLoading: false,
  hasErrors: false,
  items: null
}

const brands = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_BRAND_DETAILS:
      return Object.assign({}, state, {
        isLoading: true
      })
    case RECEIVE_BRAND_DETAILS:
      return Object.assign({}, state, {
        isLoading: false,
        hasErrors: false,
        items: action.payload
      })
    case BRAND_DETAILS_ERROR:
      return Object.assign({}, state, {
        isLoading: false,
        hasErrors: true
      })
    default:
      return state
  }
}

export default brands

export const getSingleBrandDetails = state => {
  if (!state.activeSearchParameters.brand || !state.brands.items) {
    return null
  }

  return state.brands.items[state.activeSearchParameters.brand]
}
